<template>
  <div class="product-template __donate __limited-edu __limited-edu--2021">
    <div class="wrapper-header">
      <div class="col-md-push-3 col-md-6">
        <h1 data-v-1f20e9ef="" class="text-center mb-20">
          <img src="/static/img/limited-edu/logo-lmt-edu@2x.png" width="200px" alt="Limited Education 2021" class="pd-15 ma-auto d-block" />
        </h1>
      </div>
    </div>


    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />

              <div class="form__wrapper mt-15 mb-15">

                <!-- Take Reward -->
                <div v-if="product.price" class="form__section">
                  <label class="" :class="{disable: isRewardDisabled}">
                    <strong>{{ rewardTitleText }}</strong> <br />
                    <span class="small">กรุณาเลือกขนาดเสื้อ และระบุเลขที่ผลงาน</span>
                  </label>

                  <transition name="slide-down">
                    <div class="slide-down-wrapper" :class="{disable: isRewardDisabled}">
                      <div class="form__section block-third slide-down-item">
                        <div class="text-right mb-10">
                          จำนวนเสื้อ <strong class="reward-count">{{ selectedRewardCount }}/{{ rewardCount }}</strong>
                        </div>

                        <div
                          v-for="(reward, i) in rewards"
                          :key="i"
                          class="reward-item"
                          :class="{ 'reward-item-error': reward.error }"
                        >
                          <div class="d-flex align-items-center">
                            <select class="custom-select select-change" v-model="reward.size">
                              <option
                                v-for="sizeOption in sizeOptions"
                                :key="sizeOption.text"
                                :value="sizeOption.text"
                              >
                                {{ sizeOption.text }}
                              </option>
                            </select>

                            <div class="size-description">
                              {{ getSizeDescription(reward.size) }}
                            </div>

                            <button class="btn-remove" @click.prevent="removeReward(i)">
                              ลบ
                            </button>
                          </div>

                          <div class="">
                            
                            <label class="d-flex align-items-center">
                              เลขที่ผลงาน&nbsp;<span style="color: #EA2B2B;">*</span>
                              <input
                                v-model="reward.code"
                                type="text"
                                class="code-input"
                                :class="{ error: reward.error }"
                                ref="inputCode"
                              />
                            </label>
                            <div class="small alert--remark alert--info"><span style="color: #EA2B2B;">*</span> เลขที่ผลงานจากเวปออกแบบเสื้อ <a style="text-decoration: underline" href="https://www.limitededucation.org/shirt" target="_blank">www.limitededucation.org/shirt</a></div>

                            <div v-if="reward.error" class="alert alert--error mt-5">
                              {{ reward.error }}
                            </div>
                          </div>
                        </div>

                        <div v-if="selectedRewardCount < rewardCount" class="">
                          <select v-model="selectedAddReward" @change="onSelectSize" class="custom-select select-add">
                            <option value="">เลือกขนาดเสื้อตัวที่ {{ selectedRewardCount + 1 }}</option>
                            <option
                              v-for="sizeOption in sizeOptions"
                              :key="sizeOption.text"
                              :value="sizeOption.text"
                            >
                              {{ sizeOption.text }} ({{ sizeOption.description }})
                            </option>
                          </select>
                        </div>

                        <div v-if="error.rewardConfigSize" class="alert alert--error mt-5">
                          {{ error.rewardConfigSize }}
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div><!-- end form section -->

              </div><!-- end form wrapper -->

              <donor-info v-model="attributes.info.name"
                class="pt-15" />

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="confirmReward">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  export default {
    name: 'ProductTemplateLimitedEdu2021',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        tshirtProductName: 'T-Shirt',
        attributes: {
          info: {
            name: '',
            rewardProduct: ''
          },
          page: ''
        },
        error: {
          rewardConfigSize: false
        },
        rewards: [],
        selectedAddReward: ''
      }
    },

    computed: {
      rewardTitleText () {
        if (this.rewardCount > 0) {
          return `รับเสื้อยืดลายสุภาษิตไทย ${this.rewardCount} ตัว`
        }
        return 'รับเสื้อยืดลายสุภาษิตไทย'
      },

      rewardCount () {
        const divider = 500
        return Math.floor(this.product.price / divider)
      },

      isRewardDisabled () {
        return this.product.price < 500
      },

      isTakeReward () {
        return this.attributes.info.rewardProduct === this.tshirtProductName
      },

      selectedRewardCount () {
        return this.rewards.length
      },

      sizeOptions () {
        // SS:รอบอก 34 นิ้ว,S:รอบอก 36 นิ้ว,M:รอบอก 38 นิ้ว,L:รอบอก 40 นิ้ว,XL:รอบอก 42 นิ้ว,XXL:รอบอก 44 นิ้ว
        return this.product.meta.donation_tshirt_size.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      }
    },

    created () {
      // Force reward product.
      this.attributes.info.rewardProduct = this.tshirtProductName
    },

    methods: {
      getSizeDescription (size) {
        return this.sizeOptions.find(opt => opt.text === size).description
      },

      onSelectSize (e) {
        const size = e.currentTarget.value
        if (size) {
          this.rewards.push({
            size,
            code: '',
            error: false
          })

          this.$nextTick(() => {
            this.$refs.inputCode[this.$refs.inputCode.length - 1].focus()
          })
        }
        this.selectedAddReward = ''
        this.error.rewardConfigSize = false
      },

      removeReward (index) {
        this.rewards.splice(index, 1)
      },

      validate () {
        let valid = true

        // Validate code.
        this.rewards.forEach(reward => {
          reward.error = reward.code ? false : 'กรุณากรอกเลขที่ผลงาน'
          if (reward.error) {
            valid = false
          }
        })

        // Validate size selection.
        if (this.selectedRewardCount === 0) {
          this.error.rewardConfigSize = 'กรุณาเลือกขนาดเสื้อ'
          valid = false
        } else if (this.selectedRewardCount > this.rewardCount) {
          this.error.rewardConfigSize = 'เลือกขนาดเสื้อเกินจำนวน'
          valid = false
        }

        return valid
      },

      confirmReward () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.$modal.show({
          title: 'ยืนยันข้อมูล',
          text: 'ยืนยันข้อมูลขนาดเสื้อและเลขที่ผลงาน',
          okButtonText: 'ยืนยัน',
          cancelButton: true,
          cancelButtonText: '< กลับ',
          ok: () => {
            this.donate()
          }
        })
      },

      async donate () {
        const info = JSON.parse(JSON.stringify(this.attributes.info))

        this.rewards.forEach(reward => {
          if (!info[reward.size]) {
            info[reward.size] = 0
          }
          info[reward.size]++
        })

        info.rewardConfigSize = this.rewards.map(reward => `${reward.size}; ${reward.code}`).join('\n')
        this.attributes.info = info

        // Clear previous cart info.
        await this.$store.dispatch('clearCart')

        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      },

      hasSelectedSize (text) {
        return this.selectedSize[text] > 0
      }
    },

    watch: {
      'product.price': function (amount) {
        if (!amount || amount < 500) {
          this.attributes.info.rewardProduct = ''
        } else {
          this.attributes.info.rewardProduct = this.tshirtProductName
        }
        this.rewards.splice(this.rewardCount)
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

  .custom-select {
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -ms-appearance: none;

    font-family: Prompt, Arial, sans-serif;

    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="%23000000"><polygon points="0,0 100,0 50,75"/></svg>');
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) calc(50% + 2px);
    padding-right: 20px;
    line-height: 1.5;
  }

  .select-add {
    background-color: #F0F0F0;
    border: 2px dashed #B5B5B5;
    border-radius: 4px;
    width: 100%;
    padding: 16px 20px;
  }

  .select-change {
    width: 70px;
  }

  .reward-item {
    border: 2px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;

    &.reward-item-error {
      border-color: red;
    }

    & > * {
      padding: 12px 16px;

      &:first-child {
        border-bottom: 1px solid #ccc;
      }
    }

    select {
      margin-right: 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 5px 10px;

    }

    .size-description {
      color: #999;
      flex-grow: 1;
    }

    .code-input {
      width: 125px;
      background-color: #F3E7AD;
      outline: none;
      border: 2px solid #F3E7AD;
      border-radius: 4px;
      padding: 5px 10px;
      margin-left: 12px;
      font-family: Prompt, Arial, sans-serif;

      &.error {
        border-color: red;
      }
    }
  }

  .reward-count {
    background-color: #ccc;
    border-radius: 8px;
    padding: 4px 6px;
    display: inline-block;
    line-height: 1;
  }

  .slide-down-wrapper {
    margin-top: 15px;
  }

  .current-thumbnail-wrapper {
    cursor: zoom-in;
  }

  .thumbnail-wrapper {
    border: 1px solid transparent;
    cursor: pointer;

    &.selected {
      border-color: orange;
    }
  }

  .btn-remove {
    background: #F82E2E;
    border-radius: 3px;
    color: #fff;
    border: none;
    font-family: Prompt, Arial, sans-serif;
    line-height: 1.5;
    cursor: pointer;
  }

  .size-choice {
    cursor: pointer;

    &.only-one {
      .number-field {
        display: none;
      }
    }

    &.active {
      border: 1px solid orange;
    }
  }
</style>



// WEBPACK FOOTER //
// limited-education-2021.vue?153caf5f